// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles(() => ({
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 10,
    marginBottom: 10,
    justifyContent: 'flex-start'
  },
  strategyName: {
    fontWeight: 'bold',
    color: '#434459'
  },
  strategyTitle: {
    color: '#737373',
    marginRight: 10
  },
  time: {
    color: '#737373',
    textAlign: 'center',
    marginTop: 10
  },
  firstColumn: {
    flex: 2
  },
  secondColumn: {
    flex: 1
  },
  itemText: {
    fontSize: 13
  }
}));
